import React from 'react';
import Box from '@mui/material/Box';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { TelematicDeviceProvider } from '@acorn-portal/shared/src/services/interface/Shared';
import { getTelematicsDeviceGuide } from '@acorn-portal/shared/src/utils/constants';

interface IVehicleChangeWarningProps {
	device: TelematicDeviceProvider;
}

const VehicleChangeWarning: React.FC<IVehicleChangeWarningProps> = ({ device }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Box
			sx={{
				top: 0,
				right: 0,
				backgroundColor: theme.palette.grey[200],
				color: theme.palette.secondary.main,
				p: 2,
				m: isMobile ? 0 : 4,
				mb: isMobile ? 2 : 4,
				width: 'fit-content',
				borderRadius: 2,
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				{device && (
					<Typography variant='body1' align='left'>
						{getTelematicsDeviceGuide(device)}
					</Typography>
				)}
				<ErrorIcon
					sx={{
						color: theme.palette.secondary.main,
						fontSize: 40,
						marginLeft: 'auto',
						marginRight: -1,
					}}
				/>
			</Box>
		</Box>
	);
};

export default VehicleChangeWarning;
